import { OptionType } from './types';
import { MultiValue, SingleValue } from 'react-select';

export const normalizeSelectValue = (
  val: MultiValue<OptionType> | SingleValue<OptionType>,
  isMulti: boolean
): number[] | undefined => {
  const toNumber = (val: unknown): number | undefined => {
    const valNumber = typeof val === 'number' ? val : Number(val);
    return Number.isFinite(valNumber) ? valNumber : undefined;
  };

  if (isMulti) {
    const multi = val as MultiValue<OptionType>;
    const values = multi.map((x) => toNumber(x.value)).filter((x): x is number => x !== undefined);

    return values.length ? values : undefined;
  } else {
    const single = val as SingleValue<OptionType>;

    const valNumber = toNumber(single?.value);

    return valNumber === undefined ? undefined : [valNumber];
  }
};
